/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const submitDataSchema = z.object({
  imported: z.int(),
  jobId: z.int(),
  membersAdded: z.int(),
  resourcesCreated: z.int(),
  rolesCreated: z.int(),
  teamsCreated: z.int(),
  teamsExisting: z.int(),
});
